import React from 'react'
import { InsightCardContentLoading } from '.'
import { InsightCardTransparent } from 'src/components/insights/common/cards/card-transparent'

export const InsightCardTransparentLoading: React.FC = () => {
  return (
    <InsightCardTransparent>
      <InsightCardContentLoading />
    </InsightCardTransparent>
  )
}
